<template>
  <div class="primary-alert-banner d-flex align-items-flex-start">
    <div class="image-container">
      <img
        src="@/assets/images/common/banner-icon.svg"
        alt="arrow-circle"
        class="image"
      />
      <div class="text-overlay">
        <p>{{ dayWithSuffix }} {{ monthName }}</p>
        <p>{{ dayOfWeek }}</p>
      </div>
    </div>
    <div class="d-flex flex-column content">
      <div class="drip-body title">
        {{ bannerData.title }}
      </div>
      <div class="drip-body-small font-weight-400 text">
        {{ bannerData.subtitle }}<br />
        <b class="written">
          <i>
            {{ bannerData.writtenby }}
          </i>
        </b>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'PrimaryAlertBanner',
  props: {
    bannerData: {
      type: Object
    }
  },
  data() {
    return {
      formattedDate: '',
      dayOfWeek: '',
      monthName: '',
      day: ''
    }
  },
  created() {
    this.getDate()
  },
  computed: {
    dayWithSuffix() {
      const day = this.day

      const date = moment(day, 'D')

      return date.format('Do')
    }
  },
  watch: {
    bannerData: {
      handler(newData) {
        this.getDate()
      },
      deep: true,
      immediate: true
    },
    dayWithSuffix(newVal) {},
    monthName(newVal) {},
    dayOfWeek(newVal) {}
  },
  methods: {
    getDate() {
      const date = moment(this.bannerData.date, 'DD-MM-YYYY')

      // Get the day of the week and month name using Moment.js
      this.dayOfWeek = date.format('dddd') // Full name of the day of the week (e.g., "Monday")
      this.monthName = date.format('MMM') // Full name of the month (e.g., "January")

      const customMonthAbbreviations = {
        Jan: 'Jan',
        Feb: 'Feb',
        Mar: 'March',
        Apr: 'April',
        May: 'May',
        Jun: 'June',
        Jul: 'July',
        Aug: 'August',
        Sep: 'Sept',
        Oct: 'Oct',
        Nov: 'Nov',
        Dec: 'Dec'
      }

      // Apply custom abbreviation if needed
      this.monthName =
        customMonthAbbreviations[this.monthName] || this.monthName

      // Set the formatted date and day
      this.formattedDate = date.format('DD-MM-YYYY')
      this.day = date.date()
    }
  }
}
</script>
<style lang="scss" scoped>
.primary-alert-banner {
  background: $white;
  border: 1px solid $sky-blue-500;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 24px;
  .image-container {
    min-width: 70px;
    margin-right: 12px;
    position: relative;
    display: inline-block;
  }
  .content {
    .title {
      font-weight: 700;
      letter-spacing: 0em;
      text-align: left;
      color: $noble-blue-500;
      margin-bottom: 2px;
    }
    .text {
      letter-spacing: 0em;
      text-align: left;
      color: $noble-blue-500;
    }
    .written {
      line-height: 2;
    }
  }
}
.image {
  display: block;
}

.text-overlay {
  position: absolute;
  top: 54%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: large;
  width: 80px;
  padding-left: 4px;
}

.text-overlay p {
  font-size: 10px;
  font-weight: 700;
  line-height: 13.64px;
  text-align: left;
  color: $noble-blue-500;
  margin: 0;
  text-align: center;
}

@media (min-width: 1024px) {
  .text-overlay {
    top: 50%;
  }
}

@media (min-width: 819px) and (max-width: 1024px) {
  .text-overlay {
    top: 38%;
  }
}

@media (min-width: 425px) and (max-width: 768px) {
  .text-overlay {
    top: 43%;
  }
}
@media (max-width: 425px) {
  .text-overlay {
    top: 34%;
  }
}

@media (min-width: 374px) and (max-width: 424px) {
  .text-overlay {
    top: 31%;
  }
}

@media (min-width: 320px) and (max-width: 374px) {
  .text-overlay {
    top: 25%;
  }
}
</style>
